module.exports = __webpack_public_path__ + "/assets/images/flight-not-found.png";